import Model from '../Model';
import computed from '../utils/computed';
import { getPlainContent } from '../utils/string';
export default class Post extends Model {
  number() {
    return Model.attribute('number').call(this);
  }
  discussion() {
    return Model.hasOne('discussion').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  contentType() {
    return Model.attribute('contentType').call(this);
  }
  content() {
    return Model.attribute('content').call(this);
  }
  contentHtml() {
    return Model.attribute('contentHtml').call(this);
  }
  renderFailed() {
    return Model.attribute('renderFailed').call(this);
  }
  contentPlain() {
    return computed('contentHtml', content => {
      if (typeof content === 'string') {
        return getPlainContent(content);
      }
      return content;
    }).call(this);
  }
  editedAt() {
    return Model.attribute('editedAt', Model.transformDate).call(this);
  }
  editedUser() {
    return Model.hasOne('editedUser').call(this);
  }
  isEdited() {
    return computed('editedAt', editedAt => !!editedAt).call(this);
  }
  hiddenAt() {
    return Model.attribute('hiddenAt', Model.transformDate).call(this);
  }
  hiddenUser() {
    return Model.hasOne('hiddenUser').call(this);
  }
  isHidden() {
    return computed('hiddenAt', hiddenAt => !!hiddenAt).call(this);
  }
  canEdit() {
    return Model.attribute('canEdit').call(this);
  }
  canHide() {
    return Model.attribute('canHide').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
}
flarum.reg.add('core', 'common/models/Post', Post);